/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Law_P1Inputs */

const es_l7_law_p1 = /** @type {(inputs: L7_Law_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta hace poco, alquilar una embarcación de Lista séptima era imposible: había que pasarla a lista sexta. Eso se acabó.`)
};

const gl_l7_law_p1 = /** @type {(inputs: L7_Law_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ata hai pouco, alugar unha embarcación de Lista sétima era imposible: había que pasala a lista sexta. Iso acabou.`)
};

const en_l7_law_p1 = /** @type {(inputs: L7_Law_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until recently, renting out a List 7 boat was impossible — you had to move it to List 6. That is over.`)
};

/**
* | output |
* | --- |
* | "Until recently, renting out a List 7 boat was impossible — you had to move it to List 6. That is over." |
*
* @param {L7_Law_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_law_p1 = /** @type {((inputs?: L7_Law_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Law_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_law_p1(inputs)
	if (locale === "en") return en_l7_law_p1(inputs)
	return es_l7_law_p1(inputs)
});